/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */

import React from 'react';
import { get } from 'lodash';

const SchematiDiagramSVG = (props) => {
  const { cocurrent, ediDetails } = props;

  let selected_recovery_flag = false;
  let dilution_output = {
    current_stack: 0,
    voltage: 0,
    max_all_recovery: 0,
    energy_cons: 0,
    feed_flow: 0,
    feed_pressure: 0,
    prod_flow: 0,
    prod_pressure: 0,
    conc_bleed_flow: 0,
    electrode_bleed_flow: 0,
    max_conc_inlet_press: 0,
    max_conc_outlet_press: 0,
    max_electrode_bleed_press: 0,
    FlowConfiguration: 'Counter-Current',
  };

  let calc_param = {
    selected_recovery: 'NA',
  };

  let System_units = {};

  try {
    const storedDict = localStorage?.getItem('edi-output-dict');
    if (storedDict) {
      const parsed = JSON.parse(storedDict);
      const outputdata = get(parsed, `EDI.${ediDetails?.id}`, {});
      dilution_output = outputdata?.output_user?.dilution_output ?? dilution_output;
      calc_param = outputdata?.output_user?.calc_param ?? calc_param;
    }
  } catch (err) {
    console.error('Error parsing edi-output-dict:', err);
  }

  try {
    const unitSet = localStorage?.getItem('unit_set_dict');
    if (unitSet) {
      System_units = JSON.parse(unitSet) ?? {};
    }
  } catch (err) {
    console.error('Error parsing unit_set_dict:', err);
  }

  try {
    const getStackModels = localStorage?.getItem('edi-output-dict');
    if (getStackModels) {
      const parsed = JSON.parse(getStackModels);
      selected_recovery_flag =
        parsed?.EDI?.[ediDetails?.id]?.output_user?.stack_model === 'MK-9';
    }
  } catch (err) {
    console.error('Error reading stack model:', err);
  }

  // Safe number formatting helper
  const safeToFixed = (val, digits = 1) => {
    const num = Number(val);
    return Number.isFinite(num) ? num.toFixed(digits) : '0';
  };

  return (
    <svg
      width="825"
      height="348"
      viewBox="0 0 825 348"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: '0 auto' }}
    >
      <rect x="276" y="99" width="273" height="80" rx="7" stroke="#002D62" strokeWidth="2" />
      <text fill="#002d62" x="370" y="150" fontSize="25" fontWeight="bold">Dilute</text>
      <rect x="276" y="183" width="273" height="80" rx="7" stroke="#002D62" strokeWidth="2" />
      <text fill="#002d62" x="340" y="230" fontSize="25" fontWeight="bold">Concentrate</text>
      <rect x="276" y="267" width="273" height="80" rx="7" stroke="#002D62" strokeWidth="2" />
      <text fill="#002d62" x="355" y="310" fontSize="25" fontWeight="bold">Electrode</text>

      <text fill="#1C1C1F" x="58" y="109" fontSize="14">
        {`Feed Pressure = ${safeToFixed(dilution_output?.feed_pressure)} ${System_units?.Pressure ?? ''}`}
      </text>
      <text fill="#1C1C1F" x="58" y="125" fontSize="14">
        {`Feed Flow = ${safeToFixed(dilution_output?.feed_flow, 2)} ${System_units?.['Volume Flow'] ?? ''}`}
      </text>

      <text fill="#1C1C1F" x="591" y="109" fontSize="14">
        {`Product Pressure = ${safeToFixed(dilution_output?.prod_pressure)} ${System_units?.Pressure ?? ''}`}
      </text>
      <text fill="#1C1C1F" x="591" y="125" fontSize="14">
        {`Product Flow = ${safeToFixed(dilution_output?.prod_flow, 2)} ${System_units?.['Volume Flow'] ?? ''}`}
      </text>

      <text fill="#1C1C1F" x="562" y="277" fontSize="14">
        {`Max. Electrode Bleed Pressure = ${safeToFixed(dilution_output?.max_electrode_bleed_press)} ${System_units?.Pressure ?? ''}`}
      </text>
      <text fill="#1C1C1F" x="590" y="292" fontSize="14">
        {`Electrode Bleed Flow = ${safeToFixed(dilution_output?.electrode_bleed_flow, 2)} ${System_units?.['Volume Flow'] ?? ''}`}
      </text>

      <text fill="#1C1C1F" x="283" y="30" fontSize="14">
        {`Current/Stack = ${safeToFixed(dilution_output?.current_stack)} A`}
      </text>
      <text fill="#1C1C1F" x="283" y="45" fontSize="14">
        {`Stack Voltage = ${safeToFixed(dilution_output?.voltage)} V`}
      </text>
      <text fill="#1C1C1F" x="283" y="60" fontSize="14">
        {`Energy Consumption = ${safeToFixed(dilution_output?.energy_cons, 2)} ${['gpm', 'gph', 'gps', 'gpd'].includes(System_units?.['Volume Flow']) ? 'KWh/1000gal' : 'kWh/m3'}`}
      </text>
      <text fill="#1C1C1F" x="283" y="75" fontSize="14">
        {`Maximum Recovery = ${safeToFixed(dilution_output?.max_all_recovery)} %`}
      </text>
      {selected_recovery_flag && (
        <text fill="#1C1C1F" x="283" y="90" fontSize="14">
          {`Selected Recovery = ${safeToFixed(calc_param?.selected_recovery)} ${calc_param?.selected_recovery === 'N/A' ? '' : '%'}`}
        </text>
      )}
      {!cocurrent ? (<>
        <text fill='#1C1C1F' x='25' y='195' fontSize='14'>{`Max. Conc. outlet pressure = ${dilution_output.max_conc_outlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
        <text fill='#1C1C1F' x='50' y='210' fontSize='14'>{`Conc. Bleed flow = ${dilution_output.conc_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>
        <path d="M0 223L10 228.774V217.226L0 223ZM275 223V222L9 222V223V224L275 224V223Z" fill="#002D62" />
      </>) : (<>
        <path d="M278 223L268 217.226L268 228.773L278 223ZM3 223L3 224L269 224L269 223L269 222L3 222L3 223Z" fill="#002D62" />
        <text fill='#1C1C1F' x='25' y='210' fontSize='14'>{`Max. Conc. inlet pressure = ${dilution_output.max_conc_inlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
      </>)}
      {cocurrent ? (<>
        <text fill='#1C1C1F' x='579' y='195' fontSize='14'>{`Max. Conc. outlet pressure = ${dilution_output.max_conc_outlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
        <text fill='#1C1C1F' x='604' y='210' fontSize='14'>{`Conc. Bleed flow = ${dilution_output.conc_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>
        <path d="M831 223L821 217.226L821 228.773L831 223ZM556 223L556 224L822 224L822 223L822 222L556 222L556 223Z" fill="#002D62" style={{ transform: 'translate(-6px, 5px)' }} />
      </>) : (<>
        <path d="M553 223L563 228.774V217.226L553 223ZM828 223V222L562 222V223V224L828 224V223Z" fill="#002D62" />
        <text fill='#1C1C1F' x='579' y='210' fontSize='14'>{`Max. Conc. inlet pressure = ${dilution_output.max_conc_inlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
      </>)}
      {!cocurrent ?
        <text fill='#1C1C1F' x='577' y='13' fontSize='16' style={{ transform: 'translate(-17px, 0px)' }}>Flow Configuration - Counter-Current</text> :
        <text fill='#1C1C1F' x='577' y='13' fontSize='16'>Flow Configuration - Co-Current</text>
      }
    </svg>
  );
};
export default SchematiDiagramSVG;